module.exports = __webpack_public_path__ + "static/media/Alexander Tessier.392f2b3b.png";